import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import config from 'config'

import Icon from 'srcReact/components/icons/Icon'

import { settingsActions as sa } from '../../action'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

export default function LinkBlock({ groupId, title, role, picture }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { groupDetails } = useSelector((state) => state.settings)

  const [active, setActive] = useState(groupId)

  const handleClick = () => {
    setActive(groupId)
    dispatch(sa.setGroupDetails(groupId, title, role, picture))
    dispatch(sa.setGroupFormActive(true))
  }

  return (
    <button
      className={`${styles.linkBlock} ${active === groupDetails.id ? styles.active : ''}`}
      key={groupId}
      onClick={handleClick}>
      <div className={`${styles.linkWrapper}`}>
        <div className={`${styles.linkTextBlock}`}>
          <img src={picture?.url || `${config.assetUrl}/images/background-default-mixr.jpeg`} alt={picture.name} />
          <div className={`${styles.textBlock}`}>
            <h2>{title}</h2>
            {/* <p className={`${styles.notificationsOff}`}>{t('notification_settings.options.notifications')}</p> */}
          </div>
        </div>
        <div
          role='button'
          aria-label={t('notification_settings.group_form.exlporeGroupNotifSettings', { group: title })}
          className={`${styles.linkBtnBlock}`}>
          <div className={`${styles.groupRole} ${role === 'member' ? styles.purple : styles.orange}`}>
            {t(`components.avatar.${role}`)}
          </div>
          <Icon name='arrow-right' alt='' />
        </div>
      </div>
    </button>
  )
}
